module.exports = __webpack_public_path__ + "media/site/images/products/saas_ceodash-screen3-8cc26b214a675c939ebae360061db660.png";